import EmptyRecords from '@/views/components/Common/EmptyRecords';
import ScrollPagination from '@/views/components/Paginations/ScrollPagination';
import { Col, Divider, Row } from 'antd';
import { cloneDeep, maxBy } from 'es-toolkit';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  getOCClaimNotesInProgress,
  updateOverChargeClaimInProgress,
} from '../../../../../../../../redux/Claims/OverCharge/OverChargeActions';
import { overChargeClaimsNotesSectionLocalToAPI } from '../../../../../../../../utilz/OverChargeClaimUtils';
import { routeFileSelector } from '../../../../../../../../utilz/i18n';
import Button from '../../../../../../../components/Buttons/Button';
import PrimaryLabel from '../../../../../../../components/Labels/PrimaryLabel';
import OverChargeNoteCard from './OverChargeNoteCard';

const OverChargeNotes = () => {
  const dispatch = useDispatch();
  const claimDetails = useSelector((state) => state.overChargeClaims.claimDetails);
  const claimNotes = useSelector((state) => state.overChargeClaims.claimNotes);
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  const [notesList, setNotesList] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);

  useEffect(() => {
    if (claimNotes.success && claimNotes?.data) {
      setNotesList(claimNotes?.data);
    }
  }, [claimNotes]);

  const setEditMode = (index, val) => {
    const notesListLocal = cloneDeep(notesList);
    notesListLocal[index].editMode = val;
    setNotesList(notesListLocal);
  };

  const handleCancel = (index, isNew) => () => {
    const notesLocal = cloneDeep(notesList);
    if (isNew) {
      notesLocal.splice(index, 1);
    } else {
      notesLocal[index] = {
        ...notesLocal[index],
        ...claimDetails?.data?.claimComment[index],
        editMode: false,
      };
    }
    setNotesList(notesLocal);
  };

  const handleSubmit = (data) => {
    const claimDetailsLocal = cloneDeep(claimDetails.data);
    const noteDetails = { ...data, dirtyFlag: data?.isNew ? 'I' : 'U' };
    claimDetailsLocal.claimComment = [noteDetails];
    const formData = overChargeClaimsNotesSectionLocalToAPI(claimDetailsLocal);
    formData.section = 'COMMENTS';
    formData.isRefetchDetails = true;
    formData.pageIndex = pageIndex;
    dispatch(updateOverChargeClaimInProgress(formData));
  };

  const handleDelete = (index) => () => {
    const claimDetailsLocal = cloneDeep(claimDetails.data);
    const noteDetails = { ...notesList[index], dirtyFlag: 'D' };
    claimDetailsLocal.claimComment = [noteDetails];
    claimDetailsLocal.isRefetchDetails = true;
    claimDetailsLocal.section = 'COMMENTS';
    claimDetailsLocal.pageIndex = pageIndex;
    dispatch(updateOverChargeClaimInProgress(claimDetailsLocal));
  };

  const handleAddNew = () => () => {
    let notesListLocal = cloneDeep(notesList);
    let nextSequence = maxBy(notesListLocal, ({ sequenceNo }) => Number(sequenceNo));
    nextSequence = nextSequence ? nextSequence.sequenceNo : 0;
    notesListLocal = [
      {
        commentType: undefined,
        commentText: undefined,
        sequenceNo: nextSequence + 1,
        oldCommentType: null,
        dirtyFlag: 'i',
        isNew: true,
        editMode: true,
      },
      ...notesListLocal,
    ];
    setNotesList(notesListLocal);
  };
  useEffect(() => {
    if (claimDetails.data?.fbOcKey) {
      dispatch(
        getOCClaimNotesInProgress({
          fbOcKey: claimDetails.data.fbOcKey,
          pageIndex,
        }),
      );
    }
  }, [claimDetails.data?.fbOcKey]);

  const handleNextPage = () => {
    if (claimDetails.data?.fbOcKey) {
      const nextPageNo = pageIndex + 1;
      dispatch(
        getOCClaimNotesInProgress({
          fbOcKey: claimDetails.data.fbOcKey,
          pageIndex: nextPageNo,
        }),
      );
      setPageIndex(nextPageNo);
    }
  };

  return (
    <div className="d-flex  py-16 h-100" style={{ flexDirection: 'column' }}>
      <Row className="px-30 align-items-center" justify="space-between">
        <Col>
          <PrimaryLabel className="fw-700 f-18">{t('translation:claims.overchargeClaimNotes')}</PrimaryLabel>
        </Col>
        <Col>
          <Row justify="end" gutter={16}>
            <Col>
              <Button onClick={handleAddNew()}>{t('translation:claims.addNewNote')}</Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider className="mt-0 my-16 ml-n16 vw-100 " />
      {notesList.length > 0 || claimNotes.progressing ? (
        <ScrollPagination
          className="px-30 py-10 flex-1"
          loadMore={handleNextPage}
          isLoading={claimNotes.progressing}
          hasMore={claimNotes.data?.length < claimNotes.totalRows}
          scrollOffset={30}
        >
          {notesList.map((row, index) => (
            <OverChargeNoteCard
              noteDetails={row}
              key={row.sequenceNo}
              index={index}
              editMode={Boolean(row.editMode)}
              setEditMode={setEditMode}
              handleCancel={handleCancel}
              handleSubmit={handleSubmit}
              handleDelete={handleDelete}
            />
          ))}
        </ScrollPagination>
      ) : (
        <EmptyRecords />
      )}
    </div>
  );
};

export default OverChargeNotes;
